import permissions from '@/constants/permissions'

const BeginningOfOurStory = () => import('@/views/document/BeginningOfOurStory.vue')
export default {
  path: 'poczatek-naszej-historii',
  name: 'BeginningOfOurStory',
  component: BeginningOfOurStory,
  meta: {
    requireAuth: true,
    permission: [permissions.documentView, permissions.assignedDocumentView]
  }
}
